// extracted by mini-css-extract-plugin
export default {"botaoplano":"buttoncomece_botaoplano__48+Rk","signup":"buttoncomece_signup__yY7f0"};